import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormSelectMany<T extends FieldValues>({
    control,
    disabled,
    helperText,
    label,
    options,
    required,
    small,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Controller
                control={control}
                name={value}
                render={({ field: { onBlur, onChange, ref, value: inputValue }, fieldState: { error } }) => (
                    <>
                        <Select
                            disabled={disabled}
                            error={error?.message ? true : false}
                            label={label}
                            multiple
                            onBlur={onBlur}
                            onChange={onChange}
                            ref={ref}
                            size={small ? 'small' : 'medium'}
                            sx={{ width: 250 }}
                            value={inputValue ?? []}
                        >
                            {options.length > 0 ? (
                                options?.map((option) => (
                                    <MenuItem key={option.value || option.id} value={option.value || option.id}>
                                        {value === 'tagIds'
                                            ? option.description
                                                ? `${option.description.toString()} - ${
                                                      option.id.toString().length > 25
                                                          ? option.id.toString().slice(0, 25) + '...'
                                                          : option.id.toString()
                                                  }`
                                                : option.id.length > 25
                                                  ? option.id.slice(0, 25) + '...'
                                                  : option.id
                                            : option.label || option.id}
                                    </MenuItem>
                                ))
                            ) : (
                                <Box
                                    sx={{
                                        p: 1,
                                        px: 2,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: 'text.secondary',
                                        }}
                                    >
                                        No Options
                                    </Typography>
                                </Box>
                            )}
                        </Select>
                        <FormHelperText sx={{ color: error?.message ? 'error.main' : 'initial' }}>
                            {error?.message ?? helperText}
                        </FormHelperText>
                    </>
                )}
                rules={{
                    required: required ? `${label ?? value} cannot be empty` : false,
                }}
            />
        </FormControl>
    );
}
